// utils/clearTableState.ts
export const clearTableState = (key: string | string[]) => {
  if (Array.isArray(key)) {
    key.forEach((k) => sessionStorage.removeItem(`table-state-${k}`));
  } else {
    sessionStorage.removeItem(`table-state-${key}`);
  }
};